/**
 * @param value
 * @return {string}
 */
export const formatPrice = (value) => {
    if(!value) {
        return "0.00";
    }
    let val = (value/1).toFixed(2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
};


